// מגן open-redirect (מ-v1 shell/web/login.mjs): return מתקבל רק כנתיב יחסי באותו origin.
// eslint-disable-next-line no-control-regex -- בכוונה: תווי בקרה בנתיב החזרה נדחים
const BAD = /[\s\\<>"'`]|[\u0000-\u001f\u007f]/;
export const DEFAULT_RETURN = '/artifacts';

export function safeReturn(raw: string | null | undefined): string {
  const s = String(raw ?? '');
  if (!s || s.length > 512) return DEFAULT_RETURN;
  if (!s.startsWith('/') || s.startsWith('//') || BAD.test(s)) return DEFAULT_RETURN;
  try {
    const base = 'https://aibify.invalid';
    const u = new URL(s, base);
    if (u.origin !== base) return DEFAULT_RETURN;
    if (u.pathname === '/login' || u.pathname.startsWith('/login/')) return DEFAULT_RETURN;
    return u.pathname + u.search + u.hash;
  } catch {
    return DEFAULT_RETURN;
  }
}

/** web-session-across-windows: reason=session_expired כשהסשן פקע בשרת (רענון נדחה) — /login מסביר למה. */
export const loginUrl = (returnTo: string, reason?: 'session_expired') =>
  `/login?${reason ? `reason=${reason}&` : ''}return=${encodeURIComponent(returnTo)}`;

/**
 * platform-password-recovery: return עובר בין /login ↔ /login/forgot רק כשהוא שורד את המגן כמו שהוא (יחסי, לא /login/*);
 * חיצוני/ריק → קישור נקי בלי return (לא מתרגמים אותו לברירת המחדל כדי לא "להמציא" יעד).
 */
export const keptReturn = (raw: string | null | undefined): string | null => (raw && safeReturn(raw) === raw ? raw : null);
export const forgotUrl = (raw: string | null | undefined) => {
  const r = keptReturn(raw);
  return r ? `/login/forgot?return=${encodeURIComponent(r)}` : '/login/forgot';
};
export const backToLoginUrl = (raw: string | null | undefined) => {
  const r = keptReturn(raw);
  return r ? loginUrl(r) : '/login';
};
